"use client";

import { ProjectsList } from "./ProjectsList";
import { ServicesList } from "./ServicesList";

/**
 * Plugin zarządzania projektami klienta (shell c_user_accounts) - REST/React.
 *
 * Dispatcher zakładek pluginu. Obie akcje są hash-routable i pochodzą
 * z `C_CRM_PROJECT_MANAGEMENT_INC::sharingContentForApi`:
 *   - `projects` (moduł `m_crm_projects`) -> lista projektów usera
 *   - `services` (moduł `m_services`)     -> lista usług z tych projektów
 *
 * **Bramkowanie modułami jest po stronie backendu** - gdy modułu nie ma
 * w instalacji, akcja w ogóle nie trafia do `extension.actions`, więc zakładka
 * nie pojawia się w sidebarze i ten dispatcher nigdy nie dostanie jej actionId.
 * Front celowo NIE duplikuje tej decyzji (jedno źródło prawdy).
 */
export function CCrmProjectManagementView({ actionId }: { actionId: string }) {
  if (actionId === "services") return <ServicesList />;
  return <ProjectsList />;
}

/**
 * Czy plugin obsługuje daną akcję (registry w ExtensionActionView).
 * Tylko akcje hash-routable z `sharingContentForApi`.
 */
export function cCrmProjectManagementHandlesAction(actionId: string): boolean {
  return actionId === "projects" || actionId === "services";
}
